// extracted by mini-css-extract-plugin
export var animationContainer = "_j1-0";
export var asteriskIcon = "_j1-8";
export var conversationLeftSection = "_j1-4";
export var conversationListItem = "_j1-3";
export var conversationMiddleSection = "_j1-5";
export var conversationRightSection = "_j1-6";
export var detailsContent = "_j1-1";
export var listContainer = "_j1-7";
export var modalContent = "_j1-2";